import script from "./BottomMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomMenu.vue?vue&type=script&setup=true&lang=js"

import "./BottomMenu.vue?vue&type=style&index=0&id=759625e6&lang=scss"

const __exports__ = script;

export default __exports__